import { assetsPath } from "../../utils";

const landingPage = [
  {
    image: `${assetsPath('phuket-laguna-village-residences')}/images/residence/landing-page/1.jpg`
  },
  {
    image: `${assetsPath('phuket-laguna-village-residences')}/images/residence/landing-page/2.jpg`
  },
  {
    image: `${assetsPath('phuket-laguna-village-residences')}/images/residence/landing-page/3.jpg`,
    backgroundPosition: '15% center'
  }
];

const type = [
  {
    name: "Residences",
    thumbnail: [
      {
        image: `${assetsPath('phuket-laguna-village-residences')}/images/residence/residence/thumbnail/1.jpg`
      },
      {
        image: `${assetsPath('phuket-laguna-village-residences')}/images/residence/residence/thumbnail/2_edit.jpg`
      }
    ],
    buttons: [
      {
        type: "description",
        value: 0,
        name: "Description",
        title: "Residences",
        description: {
          en:
            "<p>The ultimate in privacy and exclusivity, these grand villas feature four luxurious bedrooms overlooking a large private swimming pool and extensive gardens. Built to the most exacting standards, the grand two-storey Laguna Village Residences each occupies a built-up area of 671 square metres and sit on lagoon-fronting plots of between 1,034 to 1,482 sqm.</p>",
          cn:
            "<p>这些独栋别墅提供了私密空间与尊贵享受，包括四间豪华卧室，可以俯瞰一个大型私人游泳池和繁茂花园。<br><br>Laguna Village Residences 的两层住宅遵守最严格的标准，每套住宅建成面积671平方米，占地面积1034至1482平方米，可以远眺潟湖。</p>",
          ru:
            "<p>Эти виллы с четырьмя роскошными спальнями, окна которых выходят на большой собственный бассейн и великолепный сад, гарантируют полную приватность и эксклюзивность.<br><br>Двухэтажные здания Laguna Village Residences построены в соответствии со строжайшими стандартами. Каждое из них занимает площадь 671 кв. м, площадь расположенных в лагуне прилегающих участков составляет 1034-1482 кв. м.</p>"
        },
        images: [
          {
            image: `${assetsPath('phuket-laguna-village-residences')}/images/residence/residence/description/1.jpg`,
            backgroundPosition: '0% center'
          },
          {
            image: `${assetsPath('phuket-laguna-village-residences')}/images/residence/residence/description/2.jpg`,
            backgroundPosition: 'center bottom'
          },
          {
            image: `${assetsPath('phuket-laguna-village-residences')}/images/residence/residence/description/3.jpg`,
            backgroundPosition: 'center bottom'
          }
        ]
      },
      {
        type: "plan",
        name: "Lower Floor",
        value: 1,
        floorPlan: {
            en: `${assetsPath('phuket-laguna-village-residences')}/images/residence/residence/floor-plan/lower-floor/floor-plan/image.jpg`,
            ru: `${assetsPath('phuket-laguna-village-residences')}/images/residence/residence/floor-plan/lower-floor/floor-plan/image.jpg`,
            cn: `${assetsPath('phuket-laguna-village-residences')}/images/residence/residence/floor-plan/lower-floor/floor-plan/image.jpg`,
        },
        images: [
          {
            image: `${assetsPath('phuket-laguna-village-residences')}/images/residence/residence/floor-plan/lower-floor/images/1.jpg`
          },
          {
            image: `${assetsPath('phuket-laguna-village-residences')}/images/residence/residence/floor-plan/lower-floor/images/2.jpg`
          },
          {
            image: `${assetsPath('phuket-laguna-village-residences')}/images/residence/residence/floor-plan/lower-floor/images/3.jpg`
          },
          {
            image: `${assetsPath('phuket-laguna-village-residences')}/images/residence/residence/floor-plan/lower-floor/images/4.jpg`
          },
          {
            image: `${assetsPath('phuket-laguna-village-residences')}/images/residence/residence/floor-plan/lower-floor/images/5.jpg`
          },
          {
            image: `${assetsPath('phuket-laguna-village-residences')}/images/residence/residence/floor-plan/lower-floor/images/6.jpg`
          },
          {
            image: `${assetsPath('phuket-laguna-village-residences')}/images/residence/residence/floor-plan/lower-floor/images/7.jpg`
          },
          {
            image: `${assetsPath('phuket-laguna-village-residences')}/images/residence/residence/floor-plan/lower-floor/images/8.jpg`
          }
        ],
        image360: [
          {
            x: 950,
            y: 500,
            path: '/assets/images/residence/residence/floor-plan/lower-floor/images/8.jpg'
          }
        ],
        imageVirtual: []
      },
      {
        type: "plan",
        name: "Upper Floor",
        value: 2,
        floorPlan: {
            en: `${assetsPath('phuket-laguna-village-residences')}/images/residence/residence/floor-plan/upper-floor/floor-plan/image.jpg`,
            ru: `${assetsPath('phuket-laguna-village-residences')}/images/residence/residence/floor-plan/upper-floor/floor-plan/image.jpg`,
            cn: `${assetsPath('phuket-laguna-village-residences')}/images/residence/residence/floor-plan/upper-floor/floor-plan/image.jpg`,
        },
        images: [
          {
            image: `${assetsPath('phuket-laguna-village-residences')}/images/residence/residence/floor-plan/upper-floor/images/1.jpg`
          },
          {
            image: `${assetsPath('phuket-laguna-village-residences')}/images/residence/residence/floor-plan/upper-floor/images/2.jpg`
          },
          {
            image: `${assetsPath('phuket-laguna-village-residences')}/images/residence/residence/floor-plan/upper-floor/images/3.jpg`
          },
          {
            image: `${assetsPath('phuket-laguna-village-residences')}/images/residence/residence/floor-plan/upper-floor/images/4.jpg`
          },
          {
            image: `${assetsPath('phuket-laguna-village-residences')}/images/residence/residence/floor-plan/upper-floor/images/5.jpg`
          }
        ],
        image360: [
          {
            x: 950,
            y: 500,
            path: '/assets/images/residence/residence/floor-plan/lower-floor/images/8.jpg'
          }
        ],
        imageVirtual: [],
      }
    ]
  }
];

export default {
  landingPage,
  type
};



// WEBPACK FOOTER //
// ./src/data/PhuketLagunaVillageResidences/residence.js